import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { subscribe } from '@/lib/centrifugo'

export const Route = createFileRoute('/transactions/')({
  component: TransactionsPage,
})

function TransactionsPage() {
  const [transactions, setTransactions] = useState<any[]>([])
  const maxTx = 100

  useEffect(() => {
    let cleanup: (() => void) | undefined
    subscribe('live:transactions', (data: any) => {
      const stamped = { ...data, _receivedAt: Date.now() }
      setTransactions((prev) => {
        const next = [stamped, ...prev]
        if (next.length > maxTx) next.length = maxTx
        return next
      })
    }).then((unsub) => { cleanup = unsub })
    return () => { cleanup?.() }
  }, [])

  return (
    <div>
      <h1 style={{ fontSize: 20, marginBottom: 4 }}>Live Transactions</h1>
      <div style={{ color: 'var(--text-dim)', fontSize: 12, marginBottom: 16 }}>{transactions.length} transactions (websocket only)</div>

      <div style={{ maxHeight: 'calc(100vh - 160px)', overflow: 'auto' }}>
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Side</th>
              <th>Mint</th>
              <th>Owner</th>
              <th>SOL</th>
              <th>Volume USD</th>
              <th>Source</th>
              <th>Delay</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx: any, i: number) => {
              const data = tx.data || tx
              const mint = data.mint || (data.side === 'buy' ? data.to?.address : data.from?.address) || '-'
              const blockMs = (data.blockUnixTime || 0) * 1000
              const receivedAt = tx._receivedAt || 0
              const latencyMs = blockMs && receivedAt ? receivedAt - blockMs : null
              return (
                <tr key={data.txHash || data.signature || i}>
                  <td style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                    {blockMs ? new Date(blockMs).toLocaleTimeString() : '-'}
                  </td>
                  <td>
                    <span className={`badge ${data.side === 'buy' ? 'badge-green' : 'badge-red'}`}>{data.side}</span>
                  </td>
                  <td style={{ fontFamily: 'monospace', fontSize: 11 }}>
                    <a href={`/tokens/${mint}`}>{mint.slice(0, 12)}...</a>
                  </td>
                  <td style={{ fontFamily: 'monospace', fontSize: 11 }}>{(data.owner || '').slice(0, 8)}...</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{(data.sol_amount ?? (data.side === 'buy' ? data.from?.uiAmount : data.to?.uiAmount))?.toFixed(4) || '-'}</td>
                  <td style={{ color: 'var(--green)' }}>${data.volume_usd?.toFixed(2) || data.volumeUsd?.toFixed(2) || '-'}</td>
                  <td style={{ fontSize: 12 }}>{data.source || '-'}</td>
                  <td style={{ fontSize: 11, fontFamily: 'monospace', color: latencyMs !== null ? (latencyMs < 3000 ? 'var(--green)' : latencyMs < 10000 ? 'var(--yellow, #f59e0b)' : 'var(--red, #ef4444)') : 'var(--text-dim)' }}>
                    {latencyMs !== null ? `${(latencyMs / 1000).toFixed(1)}s` : '-'}
                  </td>
                  <td style={{ fontFamily: 'monospace', fontSize: 11 }}>{(data.signature || data.txHash || '').slice(0, 12)}...</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
      {transactions.length === 0 && <div style={{ color: 'var(--text-dim)', textAlign: 'center', padding: 20 }}>Waiting for live transactions...</div>}
    </div>
  )
}
